import {
  Box,
  Button,
  TextField,
  Snackbar,
  Alert,
  Paper,
  Typography,
  useTheme,
  InputAdornment,
} from "@mui/material";
import { Formik } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState } from "react";
import axios from "axios";
import { tokens } from "../../theme";

/* Iconos */
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import BusinessIcon from "@mui/icons-material/Business";
import DescriptionIcon from "@mui/icons-material/Description";

const apiURL = process.env.REACT_APP_API_URLDB;

const initialValues = {
  nombreUsuario: "",
  telefono: "",
  correo: "",
  descripcion: "",
  operador: "",
};

const Consultas = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const mainBlue = "#273c7d";

  const handleFormSubmit = async (values, { resetForm }) => {
    try {
      await axios.post(`${apiURL}/consulta`, values);
      resetForm();
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error al enviar la consulta:", error);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  return (
    <Box>
      {/* HERO SECTION */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${mainBlue} 0%, #1c2844 100%)`,
          py: 6,
          px: 4,
          mb: 4,
          color: "white",
          textAlign: "center",
          boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
        }}
      >
        <Typography variant="h2" fontWeight="bold" sx={{ mb: 1 }}>
          Crear una Consulta
        </Typography>
        <Typography variant="h5" sx={{ opacity: 0.9 }}>
          Por favor, complete el siguiente formulario para enviarnos su consulta.
        </Typography>
      </Box>

      {/* FORM CONTAINER */}
      <Box sx={{ maxWidth: "900px", mx: "auto", px: 2, pb: 8 }}>
        <Paper
          elevation={4}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: "16px",
            backgroundColor: theme.palette.mode === "dark" ? colors.primary[400] : "#ffffff",
          }}
        >
          <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
            {({ values, handleBlur, handleChange, handleSubmit, errors, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="outlined"
                    type="text"
                    label="Nombre de Usuario"
                    onBlur={handleBlur}
                    required
                    onChange={handleChange}
                    value={values.nombreUsuario}
                    name="nombreUsuario"
                    sx={{ gridColumn: "span 2" }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon sx={{ color: mainBlue }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    type="text"
                    required
                    label="Teléfono"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.telefono}
                    name="telefono"
                    sx={{ gridColumn: "span 2" }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PhoneIcon sx={{ color: mainBlue }} />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <TextField
                    fullWidth
                    variant="outlined"
                    type="email"
                    required
                    label="Correo Electrónico"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.correo}
                    name="correo"
                    sx={{ gridColumn: "span 2" }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon sx={{ color: mainBlue }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    type="text"
                    required
                    label="Operador"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.operador}
                    name="operador"
                    sx={{ gridColumn: "span 2" }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BusinessIcon sx={{ color: mainBlue }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    fullWidth
                    multiline
                    rows={6}
                    variant="outlined"
                    type="text"
                    required
                    label="Descripción detallada de su consulta"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.descripcion}
                    name="descripcion"
                    sx={{ gridColumn: "span 4" }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" sx={{ alignSelf: "flex-start", mt: 1.5 }}>
                          <DescriptionIcon sx={{ color: mainBlue }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <Box display="flex" justifyContent="center" mt="40px">
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: mainBlue,
                      color: "white",
                      px: 8,
                      py: 1.5,
                      borderRadius: "10px",
                      fontWeight: "bold",
                      fontSize: "1rem",
                      textTransform: "none",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "#1c2a4a",
                        transform: "translateY(-3px)",
                        boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
                      },
                    }}
                  >
                    Enviar Consulta
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
          sx={{ width: "100%", borderRadius: "8px" }}
        >
          ¡Su consulta ha sido enviada con éxito! Nos pondremos en contacto pronto.
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Consultas;
